import { render, staticRenderFns } from "./NMultiImageUploader.vue?vue&type=template&id=6bfc095c&scoped=true&"
import script from "./NMultiImageUploader.vue?vue&type=script&lang=js&"
export * from "./NMultiImageUploader.vue?vue&type=script&lang=js&"
import style0 from "./NMultiImageUploader.vue?vue&type=style&index=0&id=6bfc095c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bfc095c",
  null
  
)

export default component.exports